import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { resolveLegacyAiRedirect } from './aiTabs';

/**
 * /ai-status and /ai-usage → /ai (spec A9).
 *
 * `replace` so the back button returns to wherever the operator came from
 * rather than bouncing through the retired path.
 */
const LegacyAiRedirect: React.FC = () => {
  const { pathname, search } = useLocation();
  return <Navigate to={resolveLegacyAiRedirect(pathname, search)} replace />;
};

export default LegacyAiRedirect;
